import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import CmsElement from 'Components/Utilities/CmsElement';
import {Loading} from 'Components/Partials';
import {RenderWYSIWYG} from 'Components/Form';
import MailLink from 'Components/Utilities/MailLink';

import {asset} from 'Services/BaseHelpers';
import {getRecordValue} from 'Services/CmsHelpers';
import {translation} from 'Services/TranslationHelpers';
import {User} from 'Services';

export default class Venues extends CmsElement {
    /**
     * @var cmsElementIdentifier
     * @type {string}
     */
    cmsElementIdentifier = 'venues';

    /**
     * @var paginate
     * @type {boolean}
     */
    paginate = false;

    /**
     * @var state
     */
    state = {
        working: true
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {working, records} = this.state;

        let data = null;

        if (!working && records.data !== null && records.data.length !== 0) {
            data = records.data;

            // Filter records to just this user's region.
            if (User?.data?.region) {
                data = data.filter(venue => {
                    let regions = getRecordValue(venue, 'regions');

                    if (!regions) {
                        return false;
                    }

                    return regions.includes(User.data.region);
                });
            }
        }

        return (
            <Authenticated title="Venues">
                <h1 className="text-black text-4xl my-8 text-center">
                    Venue
                </h1>

                <div className="font-light mt-8">
                    <p className="text-center mb-12">
                       If you have any questions, we're happy to hear them at <MailLink to="bootsevents@boots.co.uk" />
                    </p>

                    {working && <Loading />}

                    { ['Support Office'].includes(User.data.first_group_name) &&
                        <>
                            <p className="text-app-blue-dark font-light mb-4 text-2xl">
                                Travel Information
                            </p>

                            <p className={"font-light mb-4"}>
                                If travelling by train or needing to hire a car,
                                please organise your own travel using Concur.
                            </p>
                        </>
                    }

                    {!working && (!data || data.length === 0) && (
                        <p className="text-center">
                            {translation('misc', 'no_items', {
                                item: translation('cms', 'venues')
                            })}
                        </p>
                    )}

                    {!working && data && data.map(this.renderVenue)}
                </div>
            </Authenticated>
        );
    }

    /**
     * @method renderVenue
     * @param {object} venue
     * @param {integer} key
     * @return {JSX.Element}
     */
    renderVenue(venue, key) {
        return (
            <div
                className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8"
                key={key}
            >
                <div>
                    <p className="text-app-blue-dark font-light mb-4 text-2xl">
                        Venue
                    </p>

                    <p className="mb-4">
                        {getRecordValue(venue, 'name')}
                    </p>

                    <p className="text-app-blue-dark font-light mb-4  text-2xl">
                        Address
                    </p>

                    <p className="mb-4">
                        {getRecordValue(venue, 'address')}
                    </p>

                    <p className="text-app-blue-dark font-light mb-4  text-2xl">
                        Website Address
                    </p>
                    <p className="mb-4 text-app-blue-dark ">
                        <a
                            href={getRecordValue(venue, 'website')}
                            target="_blank"
                            className="hover:underline"
                        >
                             {getRecordValue(venue, 'name')}
                        </a>
                    </p>

                    <p className="text-app-blue-dark font-light mb-4 text-2xl">
                        Conference Space
                    </p>

                    <p className="mb-4">
                        {getRecordValue(venue, 'conference_space')}
                    </p>

                    <details className="mb-4">
                        <summary>
                            <span className="cursor-pointer text-app-blue-dark font-light mb-4 text-2xl">
                                Travel Details - Car
                            </span>
                        </summary>

                        <p className="mt-2">
                            <RenderWYSIWYG
                                content={getRecordValue(venue, 'travel_car')}
                            />
                        </p>
                    </details>

                    <details className="mb-4">
                        <summary>
                            <span className="cursor-pointer text-app-blue-dark font-light mb-4 text-2xl">
                                Travel Details - Train
                            </span>
                        </summary>

                        <p className="mt-2">
                            <RenderWYSIWYG
                                content={getRecordValue(venue, 'travel_train')}
                            />
                        </p>
                    </details>

                    <details className="mb-4">
                        <summary>
                            <span className="cursor-pointer text-app-blue-dark font-light mb-4 text-2xl">
                                Travel Details - Airport
                            </span>
                        </summary>

                        <p className="mt-2">
                            <RenderWYSIWYG
                                content={getRecordValue(venue, 'travel_airport')}
                            />
                        </p>
                    </details>
                </div>

                <div>
                    <img
                        src={getRecordValue(venue, 'image', 'file')}
                        className="h-[32rem] mx-auto"
                    />
                </div>
            </div>
        );
    }
}
